import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { getBalanceAndPin } from "../../features/balance-and-pin/balanceAndPinSlice";
import { formattedBalance } from "../../features/balance-and-pin/utils";

import Spinner from "../../components/Spinner";
import { Footer, MainContainer, ViewBalance, Wearable, Intro } from "./styles";

import mastercardLogo from "./img/mastercard-logo.svg";
import wearable from "./img/wearable.png";
import digiseqLogo from "./img/digiseq-logo.png";
import muchBetterLogo from "./img/muchbetter-logo.svg";

const SailGp25 = () => {
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get("serialNumber");

  const dispatch = useDispatch();

  const { balanceAndPin, isLoading } = useSelector(
    (state) => state.balanceAndPin
  );

  useEffect(() => {
    if (!balanceAndPin && serialNumber) {
      dispatch(
        getBalanceAndPin({
          serial: serialNumber,
          query: "?provider=much_better"
        })
      );
    }
  }, [balanceAndPin, serialNumber, dispatch]);

  if (isLoading) return <Spinner />;

  return (
    <>
      <MainContainer>
        <Intro>
          <img src={mastercardLogo} alt="mastercard-logo" />
          <>
            <h1>
              Welcome to the Mubadala Abu Dhabi Sail Grand Prix 2025 Season
              Grand Final 
            </h1>
            <div>
              <p>{`We hope you enjoy this incredible event where speed, precision and next-level athleticism come together - set against the breathtaking Abu Dhabi skyline!`}</p>
              <p>{`Help contact`}</p>
              <p>
                <a href="mailto:mcsailgp@octagon.com">mcsailgp@octagon.com</a>
              </p>
            </div>
          </>
        </Intro>
        <ViewBalance>
          <div className="balance-container">
            <p>My Balance</p>
            <div className="balance">
              {balanceAndPin?.balanceDetails?.availableBalance
                ? formattedBalance(
                    balanceAndPin?.balanceDetails?.availableBalance,
                    balanceAndPin?.balanceDetails?.currency,
                    true
                  )
                : "N/A"}
            </div>
          </div>
        </ViewBalance>
        <Wearable className="wearable">
          <img src={wearable} alt="wearable" />
        </Wearable>

        <Footer>
          <p>Powered by</p>
          <img
            src={digiseqLogo}
            alt="digiseq-logo"
            onClick={() => window.open("https://www.digiseq.co.uk", "_blank")}
          />
          <p>Payment services provided by</p>
          <img
            src={muchBetterLogo}
            alt="muchbetter-logo"
            onClick={() => window.open("https://muchbetter.com/", "_blank")}
          />
        </Footer>
      </MainContainer>
    </>
  );
};

export default SailGp25;
